module.exports = __webpack_public_path__ + "static/media/accreditation_add_scheme.49fbe84c.svg";